import {
  loadManageOnboardingUserInfo,
  saveUserSignature,
  saveUserSignatureFailure,
  saveUserSignatureSuccess,
} from "./../../../../core/store/onboarding/onboarding.actions";
import {
  saveSignature,
  saveSignatureFailure,
  saveSignatureSuccess,
} from "./../../../../core/store/profile/profile.actions";
import { UserProfileModel } from "./../../../../models/userProfileModel";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { BaseComponent } from "src/app/core/abstracts/baseComponent";
import { SignaturePadComponent } from "@almothafar/angular-signature-pad";
import { DomSanitizer } from "@angular/platform-browser";
import { Actions, ofType } from "@ngrx/effects";
import { tap } from "rxjs";
@Component({
    selector: "app-signature",
    templateUrl: "./signature.component.html",
    styleUrls: ["./signature.component.scss"],
    standalone: false
})
export class SignatureComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  profile: UserProfileModel;
  isHRManager: boolean;
  @Input() managedUserId;
  @Input() readOnly = false;
  @ViewChild(SignaturePadComponent, { static: false })
  signaturePad: SignaturePadComponent;
  changing = false;
  savedSignatureSrc;
  savingSignature = false;

  public signaturePadOptions: Record<string, number> = {
    minWidth: 1,
    canvasWidth: 500,
    canvasHeight: 250,
  };

  constructor(
    private actions$: Actions,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private store: Store<State>,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store
        .select((s) => s.profileState.savingSignature)
        .subscribe((savingSignature) => {
          this.savingSignature = savingSignature;
        }),
    );
    if (this.managedUserId) {
      this.subs.push(
        this.store
          .select((s) => s.onboardingState.manageOnboardingUserInfo)
          .subscribe((manageOnboardingUserInfo) => {
            if (manageOnboardingUserInfo) {
              this.profile = manageOnboardingUserInfo.user;
              if (this.profile.viewSignatureUrl) {
                this.savedSignatureSrc =
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    this.profile.viewSignatureUrl,
                  );
              } else {
                this.savedSignatureSrc = null;
              }
            }
          }),
      );

      this.store.dispatch(
        loadManageOnboardingUserInfo({ userId: this.managedUserId }),
      );
    } else {
      this.subs.push(
        this.store
          .select((s) => s.profileState)
          .subscribe((profileState) => {
            this.profile = JSON.parse(JSON.stringify(profileState.profile));
            if (this.profile.viewSignatureUrl) {
              this.savedSignatureSrc =
                this.sanitizer.bypassSecurityTrustResourceUrl(
                  this.profile.viewSignatureUrl,
                );
            } else {
              this.savedSignatureSrc = null;
            }
          }),
      );
    }
    this.subs.push(
      this.store
        .select((s) => s.accountState.user?.permissionIDs)
        .subscribe((permissionIDs) => {
          this.isHRManager =
            permissionIDs &&
            !!permissionIDs.find((p) => p === 6001 || p === 6002);
        }),
      this.actions$
        .pipe(
          ofType(saveSignatureSuccess, saveUserSignatureSuccess),
          tap(() => {
            this.changing = false;
            this.cdr.markForCheck();
          }),
        )
        .subscribe(),
    );
    this.subs.push(
      this.actions$
        .pipe(
          ofType(saveSignatureFailure, saveUserSignatureFailure),
          tap(() => {
            this.changing = false;
            this.cdr.markForCheck();
          }),
        )
        .subscribe(),
    );
  }

  save() {
    const dataUrl = this.signaturePad?.toDataURL?.() ?? "";
    if (!dataUrl || dataUrl === "data:,") {
      return;
    }
    const userId =
      this.managedUserId != null ? Number(this.managedUserId) : undefined;
    if (userId != null) {
      this.store.dispatch(
        saveUserSignature({
          userId,
          data: dataUrl,
        }),
      );
    } else {
      this.store.dispatch(
        saveSignature({
          data: dataUrl,
        }),
      );
    }
  }

  ngAfterViewInit() {
    this.updateSignaturePadWidth();
    this.initSignaturePad();
  }

  @HostListener("window:resize")
  onResize() {
    this.updateSignaturePadWidth();
    if (this.signaturePad?.clear) {
      this.signaturePad.clear();
    }
  }

  startChanging() {
    this.updateSignaturePadWidth();
    this.changing = true;
    this.cdr.detectChanges();
    setTimeout(() => this.initSignaturePad(), 150);
  }

  private updateSignaturePadWidth() {
    const w =
      this.el?.nativeElement?.offsetWidth ??
      this.el?.nativeElement?.parentElement?.offsetWidth ??
      500;
    this.signaturePadOptions = {
      ...this.signaturePadOptions,
      canvasWidth: w,
      canvasHeight: 250,
    };
  }

  private initSignaturePad() {
    if (!this.signaturePad) {
      setTimeout(() => this.initSignaturePad(), 100);
      return;
    }
    const canvas = this.signaturePad.getCanvas?.();
    if (canvas == null) {
      setTimeout(() => this.initSignaturePad(), 100);
      return;
    }
    this.signaturePad.clear();
  }

  // drawComplete() {
  //   // will be notified of szimek/signature_pad's onEnd event
  //   console.log(this.signaturePad.toDataURL());
  // }

  // drawStart() {
  //   // will be notified of szimek/signature_pad's onBegin event
  //   console.log('begin drawing');
  // }
}
